<template>
  <v-dialog
    :value="visibility"
    :fullscreen="!$vuetify.breakpoint.smAndUp"
    persistent
    scrollable
  >
    <v-card>

      <v-card-text>
        <p class="dialog-headline"> {{title}} </p>
        <v-form>
          <v-text-field
            v-model="form.name"
            label="Nome"
            name="name"
            type="text"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
         <v-container>
          <v-row>
            <v-btn
              class="ml-5 px-5"
              @click="$emit('negative')"
              rounded
              depressed
            >
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-5 px-5"
              @click="$emit('positive', form)"
              dark
              color="primary"
              rounded
              depressed
            >
              Salvar
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";

export default {
  mixins: [DialogMixin],
  components: {},
  data() {
    return {
      defaultForm: {
        name: undefined
      }
    };
  },

  props: ['title'],

  mounted () {
  },

  methods: {
  }

};
</script>

<style scoped>
  .style-floating-action-button {
    top: 350px !important;
  }

  .style-second-floating-action-button {
    top: 350px !important;
  }
</style>

<style>

  .dialog-headline{
    color: #440099;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 21px;
    padding: 60px 0 30px;
  }
</style>